import { render, staticRenderFns } from "./CustomPushNotification.vue?vue&type=template&id=44d288d3&"
import script from "./CustomPushNotification.vue?vue&type=script&lang=js&"
export * from "./CustomPushNotification.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports